var buildUrl = require('../utils/build_url');

var _require = require('../utils/utils'),
    forceArray = _require.forceArray;

module.exports = function (ids) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ids = forceArray(ids);
  var uniqueId = ids.length === 1;
  var query = {
    action: 'query',
    prop: 'revisions'
  };
  query.titles = ids.join('|');
  query.format = options.format || 'json';
  if (uniqueId) query.rvlimit = options.limit || 'max';
  if (uniqueId && options.start) query.rvstart = getEpochSeconds(options.start);
  if (uniqueId && options.end) query.rvend = getEpochSeconds(options.end);
  return buildUrl(query);
};

var getEpochSeconds = function getEpochSeconds(date) {
  // Return already formatted epoch seconds:
  // if a date in milliseconds appear to be earlier than 2000-01-01, that's probably
  // already seconds actually
  if (typeof date === 'number' && date < earliestPointInMs) return date;
  return Math.trunc(new Date(date).getTime() / 1000);
};

var earliestPointInMs = new Date('2000-01-01').getTime();